import { Chart } from 'chart.js'

/**
 * Reset zoom - chart.js
 * @param chartKey
 */
export function resetZoom(chartKey: string): void {
    Chart.getChart(chartKey)?.resetZoom()
}

/**
 * Export chart to image
 * @param type
 * @param chartKey
 * @param imei
 * @param isDarkMode
 */
export function exportToImg(type: string, chartKey: string, imei: bigint | string, isDarkMode: boolean = false): void {
    const myChart = Chart.getChart(chartKey)
    if (!myChart) return

    const originalCanvas = myChart.canvas
    const tempCanvas = document.createElement('canvas')
    const tempCtx = tempCanvas.getContext('2d')

    if (!tempCtx) return

    tempCanvas.width = originalCanvas.width
    tempCanvas.height = originalCanvas.height

    // Fill background based on dark mode and chart type
    let backgroundColor = '#f5f8fa' // Default light background
    if (chartKey === 'asset-chart') {
        backgroundColor = isDarkMode ? '#1e1e2d' : '#f5f8fa'
    }
    tempCtx.fillStyle = backgroundColor
    tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height)

    // Draw the chart on top
    tempCtx.drawImage(originalCanvas, 0, 0)

    // Create download link
    const a: any = document.createElement('a')
    a.href = tempCanvas.toDataURL(type, 1) // highest quality
    a.download = imei + '_report'
    a.click()
    resetZoom(chartKey)
}